import { action as apiAction } from 'api/Api'
import {
  removeCardRelation
} from 'store/redux/cardRelations'
import sweetalert from 'sweetalert2'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  parentId: number
}

const requestRemoveCardParent = (payload: Payload) => async (dispatch, getState) => {
  const { cardId, parentId } = payload

  const optimisticAction = optimisticDispatch(dispatch, [
    removeCardRelation({
      id: parentId,
      childIds: [cardId]
    }),
    removeCardRelation({
      id: cardId,
      parentIds: [parentId],
    })
  ])

  try {
    await apiAction('RemoveCardParent', {
      cardId,
      parentCardId: parentId
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    if (error.code === 506) {
      const state = getState()

      try {
        await sweetalert({
          text: state.kanbo.locale.messages['CARD_RELATION_REMOVE_ARCHIVED_CARD'],
          type: 'info'
        })
      } catch (e) {}
    } else {
      throw error
    }
  }
}

export default requestRemoveCardParent
